import * as yup from 'yup';
import {
  MAX_CURRENT_EDUCATIONS,
  MAX_CURRENT_WORKS,
  minQtyTopSkills,
  validationMessages
} from '../../../../utils/constants';
import { isValidDate } from '../../../../utils/helpers';

/* TODO It is necessary to move all this file to utils, because the functions
    are used in AddEditFormModal, AddEditCVRecord AND ALSO in CVBaseItem! */

const getBlocksSettings = (block, initData, t) =>
  ({
    works: {
      windowTitle: t('dashboard.modal.workhistory'),
      zeroState: {
        title: '',
        company: '',
        startdate: '',
        enddate: '',
        description: '',
        id: initData?.Id,
        currentlyWorkThere: false,
        originalValue: false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentWorkQty: initData?.currentWorkQty || 0
      },
      initialState: {
        title: initData?.Title,
        company: initData?.CompanyName,
        startdate: isValidDate(new Date(initData?.StartDate)) ? new Date(initData?.StartDate) : '',
        enddate: initData?.EndDate && initData?.EndDate !== 'Present' ? new Date(initData?.EndDate) : new Date(),
        description: initData?.Description,
        id: initData?.Id,
        currentlyWorkThere: initData?.CurrentlyWorkThere || false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentWorkQty: initData?.currentWorkQty || 0,
        originalValue: initData?.originalValue
      }
    },
    educations: {
      windowTitle: t('dashboard.modal.education'),
      zeroState: {
        school: '',
        degree: '',
        degreetype: 'degreetype',
        fieldofstudy: '',
        startdate: '',
        enddate: '',
        currentlyStudyHere: false,
        originalValue: false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentEducationsQty: initData?.currentEducationsQty || 0
      },
      initialState: {
        school: initData?.UniversityName,
        degree: initData?.Degree,
        degreetype: initData?.DegreeType,
        fieldofstudy: initData?.FieldOfStudy,
        startdate: isValidDate(new Date(initData?.StartDate)) ? new Date(initData?.StartDate) : '',
        enddate: initData?.EndDate ? new Date(initData?.EndDate) : new Date(),
        id: initData?.Id,
        currentlyStudyHere: initData?.CurrentlyStudyHere || false,
        withCurrentlyCheckBox: initData?.withCurrentlyCheckBox || false,
        currentEducationsQty: initData?.currentEducationsQty || 0,
        originalValue: initData?.originalValue
      }
    },
    trainings: {
      windowTitle: t('dashboard.modal.training'),
      zeroState: {
        type: '',
        certId: '',
        valid: ''
      },
      initialState: {
        type: initData?.CertificationType,
        certId: initData?.CertificationId,
        valid: initData?.ValidUntil ? new Date(initData?.ValidUntil) : '',
        id: initData?.Id
      }
    },
    skills: {
      windowTitle: t('dashboard.modal.skills'),
      zeroState: {
        skills: []
      },
      initialState: {
        skills: initData
      },
      validationSchema: yup.object({
        skills: yup.array().test((value) => {
          const qtyTopSkills = value.filter((skill) => skill.TopSkill).length;
          return qtyTopSkills >= minQtyTopSkills;
        })
      })
    },
    industries: {
      windowTitle: t('dashboard.modal.industries'),
      zeroState: {
        industries: []
      },
      initialState: {
        industries: initData
      },
      validationSchema: yup.object({
        industries: yup.array().test((value) => value.length)
      })
    },
    functions: {
      windowTitle: t('dashboard.modal.functions'),
      zeroState: {
        functions: []
      },
      initialState: {
        functions: initData
      },
      validationSchema: yup.object({
        functions: yup.array().test((value) => value.length)
      })
    }
  }[block]);

const getInitialValues = (editeMode, initData, block, t) =>
  editeMode ? getBlocksSettings(block, initData, t)?.initialState : getBlocksSettings(block, initData, t)?.zeroState;

const getValidationSchema = (block, initData, t) => getBlocksSettings(block, initData, t)?.validationSchema;

export { getBlocksSettings, getInitialValues, getValidationSchema };
